import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5fb8f1b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "wrapper container container--large"
}
const _hoisted_2 = { class: "title-header" }
const _hoisted_3 = { class: "fw-medium" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "pt-1 mb-2" }, "Maßnahmen", -1))
const _hoisted_5 = {
  key: 0,
  class: "card-wrapper accordion",
  id: "accordionExample"
}
const _hoisted_6 = { class: "row g-0" }
const _hoisted_7 = { class: "col-md-2 position-relative p-2 p-md-0" }
const _hoisted_8 = ["aria-label"]
const _hoisted_9 = { class: "badge shadow text-dark position-absolute top-0 left-0 border border-1 ms-1 mt-3 ms-md-1 mt-md-1 bg-white" }
const _hoisted_10 = { class: "card-body p-0 px-3" }
const _hoisted_11 = { class: "m-0 text-dark" }
const _hoisted_12 = { class: "popper-content" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "flycon flycon-start flycon-16 flycon-info border-0 popper-icon"
}, null, -1))
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "card-body-items d-flex pt-1 mb-0 ps-0 d-flex flex-column flex-md-row pb-1" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = { class: "d-flex link-expand d-none d-md-flex align-items-center" }
const _hoisted_21 = ["data-bs-target", "aria-controls", "onClick"]
const _hoisted_22 = ["data-bs-target", "aria-controls", "onClick"]
const _hoisted_23 = {
  key: 0,
  class: "col-md-2 d-none d-md-flex align-items-center card-body-right"
}
const _hoisted_24 = { class: "text-dark" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Förderung", -1))
const _hoisted_26 = { class: "d-flex flex-column" }
const _hoisted_27 = ["id"]
const _hoisted_28 = { class: "col-12 border-top accordion-collapse-inner--space" }
const _hoisted_29 = {
  key: 0,
  class: "col-12 col-md-6"
}
const _hoisted_30 = {
  key: 0,
  class: "pb-4"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mb-1" }, "Form", -1))
const _hoisted_32 = { class: "mb-0" }
const _hoisted_33 = {
  key: 1,
  class: "pb-4"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mb-1" }, "Lage", -1))
const _hoisted_35 = { class: "mb-0" }
const _hoisted_36 = {
  key: 2,
  class: "pb-4"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mb-1" }, "Kulisse", -1))
const _hoisted_38 = { class: "mb-0" }
const _hoisted_39 = { key: 3 }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mb-1" }, "Förderung", -1))
const _hoisted_41 = { class: "" }
const _hoisted_42 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" Greening-Faktor ")
const _hoisted_44 = { class: "list-unstyled ps-2 custom-list--dott-hide" }
const _hoisted_45 = ["innerHTML"]
const _hoisted_46 = {
  key: 1,
  class: "mb-0"
}
const _hoisted_47 = /*#__PURE__*/_createTextVNode(" Greening-Abzug ")
const _hoisted_48 = { class: "list-unstyled custom-list--dott-hide ps-2" }
const _hoisted_49 = ["innerHTML"]
const _hoisted_50 = {
  key: 1,
  class: "col-12 col-md-6"
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "mb-1",
  innerHTML: 'Bewirtschaftungshinweise'
}, null, -1))
const _hoisted_52 = { class: "mb-0" }
const _hoisted_53 = { key: 0 }
const _hoisted_54 = /*#__PURE__*/_createTextVNode(" Lagetreue: ")
const _hoisted_55 = ["innerHTML"]
const _hoisted_56 = { key: 1 }
const _hoisted_57 = /*#__PURE__*/_createTextVNode(" Einsaat-Termine ")
const _hoisted_58 = { class: "ps-2" }
const _hoisted_59 = ["innerHTML"]
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "flycon flycon-start flycon-16 flycon-info border-0"
}, null, -1))
const _hoisted_61 = { key: 2 }
const _hoisted_62 = /*#__PURE__*/_createTextVNode(" Düngung ")
const _hoisted_63 = { class: "ps-2" }
const _hoisted_64 = { key: 3 }
const _hoisted_65 = /*#__PURE__*/_createTextVNode(" Pflanzenschutz ")
const _hoisted_66 = { class: "ps-2" }
const _hoisted_67 = { key: 4 }
const _hoisted_68 = { class: "d-flex" }
const _hoisted_69 = /*#__PURE__*/_createTextVNode(" Bewirtschaftungsruhe: ")
const _hoisted_70 = { key: 5 }
const _hoisted_71 = /*#__PURE__*/_createTextVNode(" Bodenbearbeitung ")
const _hoisted_72 = { class: "ps-2" }
const _hoisted_73 = { key: 6 }
const _hoisted_74 = /*#__PURE__*/_createTextVNode(" Befahren: ")
const _hoisted_75 = ["innerHTML"]
const _hoisted_76 = { key: 7 }
const _hoisted_77 = /*#__PURE__*/_createTextVNode(" Viehbesatz ")
const _hoisted_78 = { class: "ps-2" }
const _hoisted_79 = ["innerHTML"]
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "flycon flycon-start flycon-16 flycon-info border-0"
}, null, -1))
const _hoisted_81 = { key: 8 }
const _hoisted_82 = /*#__PURE__*/_createTextVNode(" Mahd-Termine ")
const _hoisted_83 = { class: "list-unstyled" }
const _hoisted_84 = { key: 9 }
const _hoisted_85 = /*#__PURE__*/_createTextVNode(" Beweidung ")
const _hoisted_86 = { class: "" }
const _hoisted_87 = { key: 10 }
const _hoisted_88 = /*#__PURE__*/_createTextVNode(" Umbruch zur Nachsaat oder Einsaat einer Folgekultur ")
const _hoisted_89 = { class: "" }
const _hoisted_90 = { key: 11 }
const _hoisted_91 = /*#__PURE__*/_createTextVNode(" Nutzung des Aufwuchses ")
const _hoisted_92 = { class: "ps-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TestSystemContainer = _resolveComponent("TestSystemContainer")!
  const _component_FilterStates = _resolveComponent("FilterStates")!
  const _component_FilterOverview = _resolveComponent("FilterOverview")!
  const _component_Popper = _resolveComponent("Popper")!
  const _component_DateRangeDescriptionSnippet = _resolveComponent("DateRangeDescriptionSnippet")!
  const _component_CardBorderedBody = _resolveComponent("CardBorderedBody")!
  const _component_CardBordered = _resolveComponent("CardBordered")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ListViewCards = _resolveComponent("ListViewCards")!
  const _component_SearchEmptyState = _resolveComponent("SearchEmptyState")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_ctx.measures && _ctx.pagination)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_TestSystemContainer),
        _createVNode(_component_FilterStates),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.pagination.totalItems) + " Maßnahmen " + _toDisplayString(_ctx.getSelectedStates()), 1),
          _hoisted_4
        ]),
        _createVNode(_component_FilterOverview, {
          "view-icon-toggle": _ctx.viewIconToggle,
          onUpdateIconToggle: _ctx.setViewIconToggleValue
        }, null, 8, ["view-icon-toggle", "onUpdateIconToggle"]),
        _createVNode(_Transition, {
          name: "fade",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (!_ctx.viewIconToggle && _ctx.pagination.totalItems !== 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.measures, (measure, index) => {
                    return (_openBlock(), _createBlock(_component_router_link, {
                      class: "card mb-5 border rounded-1 text-decoration-none mb-md-2 card--shadow card--no-border",
                      to: {
            name: 'MeasuresDetail',
            params: {
              id: measure.id,
              label: _ctx.urlFormatter.encodeStringForURL(measure.label),
            },
          },
                      key: index,
                      style: _normalizeStyle(
            _ctx.toggleCard && index === _ctx.toggledCardIndex
              ? _ctx.addBorderColorOnCollapse(measure.measureType.color)
              : ''
          )
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", {
                              class: "card-img bg-light ratio ratio-16x9",
                              style: _normalizeStyle(measure.titleImage ? _ctx.bgImage(measure.titleImage) : ''),
                              role: "img",
                              "aria-label": measure.label
                            }, null, 12, _hoisted_8),
                            _createElementVNode("span", _hoisted_9, _toDisplayString(measure.validityPeriodRange.validityPeriodStart) + " - " + _toDisplayString(measure.validityPeriodRange.validityPeriodEnd), 1)
                          ]),
                          _createElementVNode("div", {
                            class: _normalizeClass(["d-flex justify-content-center align-items-center p-2 pt-md-0 pb-md-0", measure.measureBonus.length ? 'col-md-8' : 'col-10'])
                          }, [
                            _createElementVNode("div", _hoisted_10, [
                              _createElementVNode("span", {
                                class: "leading pb-1",
                                style: _normalizeStyle('color:' + measure.measureType.color)
                              }, _toDisplayString(measure.measureType.label), 5),
                              _createElementVNode("h3", _hoisted_11, [
                                _createTextVNode(_toDisplayString(measure.label) + " ", 1),
                                (measure.additionalService)
                                  ? (_openBlock(), _createBlock(_component_Popper, {
                                      key: 0,
                                      hover: "",
                                      arrow: "",
                                      "append-to-body": "true",
                                      placement: "top",
                                      class: "border-0 m-0 popper-wrapper position-relative align-middle d-none d-md-inline-block custom-list--dott"
                                    }, {
                                      content: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_12, " Zugeordnete Grundmaßnahme: " + _toDisplayString(measure.additionalServiceLabel), 1)
                                      ]),
                                      default: _withCtx(() => [
                                        _hoisted_13
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : _createCommentVNode("", true),
                                (measure.code)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, " | " + _toDisplayString(measure.code), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("ul", _hoisted_15, [
                                _createElementVNode("li", null, _toDisplayString(measure.federalState.label), 1),
                                _createElementVNode("li", null, _toDisplayString(measure.supportProgramm.label), 1),
                                _createElementVNode("li", null, _toDisplayString(_ctx.durationFormatter.format(
                        measure.commitmentTime.value,
                        "Jahre"
                      )), 1),
                                (measure.widthMin || measure.widthMax)
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_16, _toDisplayString(_ctx.measurementFormatter.formatRange(
                        { from: measure.widthMin, to: measure.widthMax },
                        "m"
                      )), 1))
                                  : _createCommentVNode("", true),
                                (measure.hectareMin || measure.hectareMax)
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_17, _toDisplayString(_ctx.measurementFormatter.formatRange(
                        { from: measure.hectareMin, to: measure.hectareMax },
                        "ha"
                      )), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              (measure.shortDescription)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                    _createElementVNode("span", {
                                      class: "text-color--medium-emphasis",
                                      innerHTML: measure.shortDescription
                                    }, null, 8, _hoisted_19)
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_20, [
                                _createElementVNode("a", {
                                  class: "link-dark fw-medium fs-5 accordion-button text-dark bg-transparent shadow-none p-0",
                                  "data-bs-toggle": "collapse",
                                  "data-bs-target": '#collapseExample-' + index,
                                  "aria-expanded": "true",
                                  "aria-controls": 'collapseExample-' + index,
                                  onClick: _withModifiers(($event: any) => (_ctx.togglingCard(index)), ["prevent"])
                                }, "Weitere Informationen anzeigen", 8, _hoisted_21),
                                _createElementVNode("button", {
                                  "aria-hidden": "true",
                                  class: _normalizeClass(["btn btn-link flycon flycon-top flycon-20 text-dark lh-0 rounded-circle p-1 border-0", 
                      _ctx.toggleCard && _ctx.toggledCardIndex === index
                        ? 'flycon-chevron-up'
                        : 'flycon-chevron-down'
                    ]),
                                  "aria-label": "reload",
                                  type: "button",
                                  "data-bs-toggle": "collapse",
                                  "data-bs-target": '#collapseExample-' + index,
                                  "aria-expanded": "true",
                                  "aria-controls": 'collapseExample-' + index,
                                  onClick: _withModifiers(($event: any) => (_ctx.togglingCard(index)), ["prevent"])
                                }, null, 10, _hoisted_22)
                              ])
                            ])
                          ], 2),
                          (measure.measureBonus.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                _createElementVNode("div", _hoisted_24, [
                                  _hoisted_25,
                                  _createElementVNode("div", _hoisted_26, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(measure.measureBonus, (item, index) => {
                                      return (_openBlock(), _createElementBlock("span", { key: index }, _toDisplayString(_ctx.getMeasureBonusItemOutput(item, true)), 1))
                                    }), 128))
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", {
                          id: 'collapseExample-' + index,
                          class: "row accordion-collapse collapse text-dark custom-marker-list--expand",
                          "aria-labelledby": "headingTwo",
                          "data-bs-parent": "#accordionExample"
                        }, [
                          _createElementVNode("div", _hoisted_28, [
                            _createVNode(_Transition, {
                              name: "fade",
                              mode: "out-in"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_CardBordered, { wrapperClass: 'border-0' }, {
                                  body: _withCtx(() => [
                                    _createVNode(_component_CardBorderedBody, null, {
                                      gridContent: _withCtx(() => [
                                        (
                            measure.form.length ||
                            measure.targetArea.length ||
                            measure.scenery.length ||
                            measure.measureBonus.length
                          )
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                              (measure.form.length)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                                    _hoisted_31,
                                                    _createElementVNode("ul", _hoisted_32, [
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(measure.form, (item, index) => {
                                                        return (_openBlock(), _createElementBlock("li", {
                                                          class: "mb-0 text-nowrap",
                                                          key: index
                                                        }, _toDisplayString(item.label), 1))
                                                      }), 128))
                                                    ])
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (measure.targetArea.length)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                                    _hoisted_34,
                                                    _createElementVNode("ul", _hoisted_35, [
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(measure.targetArea, (item, index) => {
                                                        return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(item.label), 1))
                                                      }), 128))
                                                    ])
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (measure.scenery.length)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                                    _hoisted_37,
                                                    _createElementVNode("ul", _hoisted_38, [
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(measure.scenery, (item, index) => {
                                                        return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(item.label), 1))
                                                      }), 128))
                                                    ])
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (measure.measureBonus.length)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                                    _hoisted_40,
                                                    _createElementVNode("ul", _hoisted_41, [
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(measure.measureBonus, (item, index) => {
                                                        return (_openBlock(), _createElementBlock("li", {
                                                          class: "mb-0",
                                                          key: index
                                                        }, _toDisplayString(_ctx.getMeasureBonusItemOutput(item, false)), 1))
                                                      }), 128)),
                                                      (measure.greening.length)
                                                        ? (_openBlock(), _createElementBlock("li", _hoisted_42, [
                                                            _hoisted_43,
                                                            _createElementVNode("ul", _hoisted_44, [
                                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(measure.greening, (item, index) => {
                                                                return (_openBlock(), _createElementBlock("li", {
                                                                  class: _normalizeClass(["mb-0", {
                                      'custom-list--hide':
                                        item.greeningAllowed === false,
                                    }]),
                                                                  key: index
                                                                }, [
                                                                  _createElementVNode("span", {
                                                                    class: "text-wrap d-inline custom-inline--content",
                                                                    innerHTML: 
                                        _ctx.booleanFormatter.format(
                                          item.greeningAllowed
                                        ) +
                                        ' | ' +
                                        item.greeningFactor +
                                        ' | ' +
                                        item.greeningFactorDescription
                                      
                                                                  }, null, 8, _hoisted_45)
                                                                ], 2))
                                                              }), 128))
                                                            ])
                                                          ]))
                                                        : _createCommentVNode("", true),
                                                      (measure.greeningReduction.length)
                                                        ? (_openBlock(), _createElementBlock("li", _hoisted_46, [
                                                            _hoisted_47,
                                                            _createElementVNode("ul", _hoisted_48, [
                                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(measure.greeningReduction, (item, index) => {
                                                                return (_openBlock(), _createElementBlock("li", {
                                                                  class: _normalizeClass(["mb-0", {
                                      'custom-list--hide':
                                        item.greeningReduction === false,
                                    }]),
                                                                  key: index
                                                                }, [
                                                                  _createElementVNode("span", {
                                                                    class: "text-wrap d-inline custom-inline--content",
                                                                    innerHTML: 
                                        _ctx.currencyFormatter.format(
                                          item.greeningReduction,
                                          '€/ha'
                                        ) +
                                        ' | ' +
                                        item.greeningReductionDescription
                                      
                                                                  }, null, 8, _hoisted_49)
                                                                ], 2))
                                                              }), 128))
                                                            ])
                                                          ]))
                                                        : _createCommentVNode("", true)
                                                    ])
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (
                            measure.fixedArea.label ||
                            measure.sowings.length ||
                            measure.fertilizationTypeOfRestriction.length ||
                            measure.fertilizationType.length ||
                            measure.pesticidesUsage.length ||
                            measure.managementRest.from ||
                            measure.managementRest.until ||
                            measure.tillage.length ||
                            measure.driveOn.label !== ('' || '-') ||
                            measure.soilCultivationForReseedings.length ||
                            measure.useOfVegetationDates.length
                          )
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                              _createElementVNode("div", null, [
                                                _hoisted_51,
                                                _createElementVNode("ul", _hoisted_52, [
                                                  (measure.fixedArea.label)
                                                    ? (_openBlock(), _createElementBlock("li", _hoisted_53, [
                                                        _hoisted_54,
                                                        _createElementVNode("span", {
                                                          innerHTML: measure.fixedArea.label
                                                        }, null, 8, _hoisted_55)
                                                      ]))
                                                    : _createCommentVNode("", true),
                                                  (measure.sowings.length)
                                                    ? (_openBlock(), _createElementBlock("li", _hoisted_56, [
                                                        _hoisted_57,
                                                        _createElementVNode("ul", _hoisted_58, [
                                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(measure.sowings, (item, index) => {
                                                            return (_openBlock(), _createElementBlock("li", { key: index }, [
                                                              _createTextVNode(_toDisplayString(_ctx.dateFormatter.getDateItemFormatted(
                                        item,
                                        "DD. MMMM",
                                        true
                                      ).range) + " ", 1),
                                                              (item.description)
                                                                ? (_openBlock(), _createBlock(_component_Popper, {
                                                                    key: 0,
                                                                    hover: "",
                                                                    arrow: "",
                                                                    "append-to-body": "true",
                                                                    placement: "top",
                                                                    class: "border-0 m-0 popper-wrapper position-relative align-middle d-none d-md-inline-block custom-list--dott"
                                                                  }, {
                                                                    content: _withCtx(() => [
                                                                      _createElementVNode("div", {
                                                                        class: "popper-content",
                                                                        innerHTML: item.description
                                                                      }, null, 8, _hoisted_59)
                                                                    ]),
                                                                    default: _withCtx(() => [
                                                                      _hoisted_60
                                                                    ]),
                                                                    _: 2
                                                                  }, 1024))
                                                                : _createCommentVNode("", true)
                                                            ]))
                                                          }), 128))
                                                        ])
                                                      ]))
                                                    : _createCommentVNode("", true),
                                                  (
                                  measure.fertilizationTypeOfRestriction.length
                                )
                                                    ? (_openBlock(), _createElementBlock("li", _hoisted_61, [
                                                        _hoisted_62,
                                                        _createElementVNode("ul", _hoisted_63, [
                                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(measure.fertilizationTypeOfRestriction, (item, index) => {
                                                            return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(item.label), 1))
                                                          }), 128))
                                                        ])
                                                      ]))
                                                    : _createCommentVNode("", true),
                                                  (measure.pesticidesUsage.length)
                                                    ? (_openBlock(), _createElementBlock("li", _hoisted_64, [
                                                        _hoisted_65,
                                                        _createElementVNode("ul", _hoisted_66, [
                                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(measure.pesticidesUsage, (item, index) => {
                                                            return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(item.label), 1))
                                                          }), 128))
                                                        ])
                                                      ]))
                                                    : _createCommentVNode("", true),
                                                  (
                                  measure.managementRest.from ||
                                  measure.managementRest.until
                                )
                                                    ? (_openBlock(), _createElementBlock("li", _hoisted_67, [
                                                        _createElementVNode("div", _hoisted_68, [
                                                          _hoisted_69,
                                                          _createVNode(_component_DateRangeDescriptionSnippet, {
                                                            item: measure.managementRest,
                                                            "is-interval": true,
                                                            wrapperClass: 'mt-n1 ms-1',
                                                            short: true
                                                          }, null, 8, ["item"])
                                                        ])
                                                      ]))
                                                    : _createCommentVNode("", true),
                                                  (measure.tillage.length)
                                                    ? (_openBlock(), _createElementBlock("li", _hoisted_70, [
                                                        _hoisted_71,
                                                        _createElementVNode("ul", _hoisted_72, [
                                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(measure.tillage, (item, index) => {
                                                            return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(item.label), 1))
                                                          }), 128))
                                                        ])
                                                      ]))
                                                    : _createCommentVNode("", true),
                                                  (measure.driveOn.label !== ('' || '-'))
                                                    ? (_openBlock(), _createElementBlock("li", _hoisted_73, [
                                                        _hoisted_74,
                                                        _createElementVNode("span", {
                                                          innerHTML: measure.driveOn.label
                                                        }, null, 8, _hoisted_75)
                                                      ]))
                                                    : _createCommentVNode("", true),
                                                  (measure.livestock.length)
                                                    ? (_openBlock(), _createElementBlock("li", _hoisted_76, [
                                                        _hoisted_77,
                                                        _createElementVNode("ul", _hoisted_78, [
                                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(measure.livestock, (item, index) => {
                                                            return (_openBlock(), _createElementBlock("li", { key: index }, [
                                                              _createTextVNode(_toDisplayString(_ctx.getLivestockOutput(item)) + " ", 1),
                                                              (item.description)
                                                                ? (_openBlock(), _createBlock(_component_Popper, {
                                                                    key: 0,
                                                                    hover: "",
                                                                    arrow: "",
                                                                    "append-to-body": "true",
                                                                    placement: "top",
                                                                    class: "border-0 m-0 popper-wrapper position-relative align-middle d-none d-md-inline-block custom-list--dott"
                                                                  }, {
                                                                    content: _withCtx(() => [
                                                                      _createElementVNode("div", {
                                                                        class: "popper-content",
                                                                        innerHTML: item.description
                                                                      }, null, 8, _hoisted_79)
                                                                    ]),
                                                                    default: _withCtx(() => [
                                                                      _hoisted_80
                                                                    ]),
                                                                    _: 2
                                                                  }, 1024))
                                                                : _createCommentVNode("", true)
                                                            ]))
                                                          }), 128))
                                                        ])
                                                      ]))
                                                    : _createCommentVNode("", true),
                                                  (measure.mahdDates.length)
                                                    ? (_openBlock(), _createElementBlock("li", _hoisted_81, [
                                                        _hoisted_82,
                                                        _createElementVNode("ul", _hoisted_83, [
                                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(measure.mahdDates, (item, index) => {
                                                            return (_openBlock(), _createElementBlock("li", {
                                                              class: "d-flex",
                                                              key: index
                                                            }, [
                                                              _createElementVNode("ul", null, [
                                                                _createElementVNode("li", null, [
                                                                  _createVNode(_component_DateRangeDescriptionSnippet, {
                                                                    item: item,
                                                                    "is-interval": true,
                                                                    short: true,
                                                                    wrapperClass: 'mt-n1'
                                                                  }, null, 8, ["item"])
                                                                ])
                                                              ])
                                                            ]))
                                                          }), 128))
                                                        ])
                                                      ]))
                                                    : _createCommentVNode("", true),
                                                  (measure.grazing.length)
                                                    ? (_openBlock(), _createElementBlock("li", _hoisted_84, [
                                                        _hoisted_85,
                                                        _createElementVNode("ul", _hoisted_86, [
                                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(measure.grazing, (item, index) => {
                                                            return (_openBlock(), _createElementBlock("li", {
                                                              key: index,
                                                              class: "d-flex"
                                                            }, [
                                                              _createElementVNode("ul", null, [
                                                                _createElementVNode("li", null, [
                                                                  _createVNode(_component_DateRangeDescriptionSnippet, {
                                                                    item: item,
                                                                    "is-interval": true,
                                                                    wrapperClass: 'mt-n1',
                                                                    short: true
                                                                  }, null, 8, ["item"])
                                                                ])
                                                              ])
                                                            ]))
                                                          }), 128))
                                                        ])
                                                      ]))
                                                    : _createCommentVNode("", true),
                                                  (
                                  measure.soilCultivationForReseedings.length
                                )
                                                    ? (_openBlock(), _createElementBlock("li", _hoisted_87, [
                                                        _hoisted_88,
                                                        _createElementVNode("ul", _hoisted_89, [
                                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(measure.soilCultivationForReseedings, (item, index) => {
                                                            return (_openBlock(), _createElementBlock("li", {
                                                              key: index,
                                                              class: "d-flex"
                                                            }, [
                                                              _createElementVNode("ul", null, [
                                                                _createElementVNode("li", null, [
                                                                  _createVNode(_component_DateRangeDescriptionSnippet, {
                                                                    item: item,
                                                                    "is-interval": true,
                                                                    wrapperClass: 'mt-n1',
                                                                    short: true
                                                                  }, null, 8, ["item"])
                                                                ])
                                                              ])
                                                            ]))
                                                          }), 128))
                                                        ])
                                                      ]))
                                                    : _createCommentVNode("", true),
                                                  (measure.useOfVegetationDates.length)
                                                    ? (_openBlock(), _createElementBlock("li", _hoisted_90, [
                                                        _hoisted_91,
                                                        _createElementVNode("ul", _hoisted_92, [
                                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(measure.useOfVegetationDates, (item, index) => {
                                                            return (_openBlock(), _createElementBlock("li", { key: index }, [
                                                              _createVNode(_component_DateRangeDescriptionSnippet, {
                                                                item: item,
                                                                "is-interval": true,
                                                                wrapperClass: 'mt-n1',
                                                                short: true
                                                              }, null, 8, ["item"])
                                                            ]))
                                                          }), 128))
                                                        ])
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ])
                        ], 8, _hoisted_27)
                      ]),
                      _: 2
                    }, 1032, ["to", "style"]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_Transition, {
          name: "fade",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ListViewCards, {
              iconToggle: _ctx.viewIconToggle,
              measures: _ctx.measures
            }, null, 8, ["iconToggle", "measures"])
          ]),
          _: 1
        }),
        _createVNode(_Transition, {
          name: "fade",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (_ctx.pagination.totalItems === 0)
              ? (_openBlock(), _createBlock(_component_SearchEmptyState, {
                  key: 0,
                  wrapperClass: { 'pt-2': _ctx.viewIconToggle }
                }, null, 8, ["wrapperClass"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        (_ctx.measures.length)
          ? (_openBlock(), _createBlock(_component_Pagination, { key: 0 }))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}